// 코스별 실습 프로젝트 데이터 (카드 + 상세 페이지 공용)
//
// 구조:
// - slug: URL 키 (course route 하위 경로)
// - title, description, image, skills: 카드용 (기존 호환)
// - overview: 상세 페이지 2~3 문단 설명
// - features: 핵심 기능 bullet
// - learningGoals: 학습 목표 bullet
// - techStack: 사용 기술/도구 (skills 확장판)
// - screenshots: 추가 이미지 (옵션)
// - demoLink, repoLink: 외부 링크 (옵션)

export const projectsByCourse = {
  java: [
    {
      slug: 'calculator',
      title: '콘솔 기반 계산기 프로그램',
      description:
        'Java의 기본 기능을 활용하여 덧셈, 뺄셈, 곱셈, 나눗셈 등의 연산이 가능한 계산기를 구현합니다. 예외 처리를 통해 견고한 애플리케이션을 만드는 방법을 경험합니다.',
      image: '/assets/images/java-project-calculator.png',
      skills: ['Java 기본 문법', '예외 처리', '객체지향 설계', '입출력 처리'],
      overview:
        '터미널에서 동작하는 계산기 애플리케이션을 만들면서 Java의 기본 문법과 객체지향 설계의 첫 단추를 익힙니다. 사용자가 입력한 식을 파싱해서 사칙연산을 수행하고, 0으로 나누기·잘못된 입력 같은 비정상 케이스를 예외 처리로 안전하게 처리합니다. 단순한 절차형 코드에서 시작해 책임을 가진 클래스로 구조를 점진적으로 개선해 보는 것이 핵심입니다.',
      features: [
        '사칙연산(+, -, *, /) 및 우선순위 처리',
        '연속 연산 / 직전 결과 재사용',
        '입력 유효성 검사와 사용자 친화적 에러 메시지',
        '예외 계층 설계 (DivideByZero, InvalidExpression 등)',
        '연산 기록(History) 메모리 보관 및 조회',
      ],
      learningGoals: [
        'Java 기본 자료형, 연산자, 제어문 활용',
        'Scanner를 활용한 콘솔 입출력 처리',
        'try/catch와 사용자 정의 예외 설계',
        '책임 단위로 클래스를 분리하는 객체지향 사고',
        '단위 테스트(JUnit) 작성 입문',
      ],
      techStack: ['Java 17', 'JUnit 5', 'Maven', 'IntelliJ IDEA'],
    },
    {
      slug: 'grade-system',
      title: '학생 성적 관리 시스템',
      description:
        '학생 정보와 성적을 관리하는 시스템을 개발합니다. 자료구조를 활용한 데이터 관리, 파일 입출력을 통한 영구 저장, 그리고 간단한 통계 기능을 구현합니다.',
      image: '/assets/images/java-project-grade-system.png',
      skills: ['Java Collection', '파일 입출력', '객체 지향 설계', '통계 처리'],
      overview:
        '학생 / 과목 / 성적이라는 세 가지 도메인 객체를 정의하고, Collection Framework로 메모리상에서 관리하다가 파일에 영구 저장하는 흐름까지 만들어 봅니다. CRUD를 갖춘 메뉴 기반 콘솔 앱을 완성하면서 객체 간 관계 모델링과 데이터 무결성에 대한 감각을 익힙니다. 평균/최고/최저점 같은 통계 기능을 직접 구현하면서 컬렉션 순회와 람다·스트림 사용법도 자연스럽게 학습합니다.',
      features: [
        '학생 / 과목 / 성적 등록·수정·삭제',
        '학번·이름·과목별 검색 및 필터링',
        '평균, 표준편차, 학점 분포 통계',
        '텍스트 / CSV 파일로 저장 및 불러오기',
        '메뉴 기반 콘솔 UI와 명령어 라우팅',
      ],
      learningGoals: [
        'List, Map, Set 등 Collection Framework 활용',
        'Stream API로 통계 계산하기',
        'BufferedReader / BufferedWriter 기반 파일 I/O',
        '도메인 모델과 영속화 계층의 분리',
        '예외 안전성과 트랜잭션적 관점',
      ],
      techStack: ['Java 17', 'Collections', 'Stream API', 'CSV / Plain Text I/O'],
    },
    {
      slug: 'chat-app',
      title: '멀티스레드 채팅 애플리케이션',
      description:
        '소켓 프로그래밍과 멀티스레딩을 활용하여 실시간 채팅 애플리케이션을 구현합니다. 서버와 클라이언트 간의 통신, 다중 사용자 처리 등 네트워크 프로그래밍의 핵심을 배웁니다.',
      image: '/assets/images/java-project-chat-app.png',
      skills: ['소켓 프로그래밍', '멀티스레딩', '동시성 제어', '사용자 인터페이스'],
      overview:
        'TCP 소켓과 스레드를 직접 다루며 실시간 메시지 송수신이 가능한 채팅 서버/클라이언트를 구현합니다. 한 명의 사용자만 접속할 수 있는 단순 에코 서버에서 시작해, 다중 클라이언트를 동시에 처리하는 멀티스레드 서버, 닉네임 기반 1:1 귓속말, 채팅방 분리까지 점진적으로 확장합니다. 동시성 문제와 자원 공유의 위험성, 그리고 그것을 안전하게 다루는 패턴을 직접 경험하는 것이 목표입니다.',
      features: [
        'TCP 소켓 기반 서버 / 클라이언트 통신',
        '다중 사용자 동시 접속 처리 (스레드 풀)',
        '닉네임 입장 / 퇴장 알림 브로드캐스트',
        '귓속말 / 채팅방(채널) 분리',
        '간단한 메시지 프로토콜 설계',
      ],
      learningGoals: [
        'java.net.Socket / ServerSocket 사용',
        'Runnable, Thread, ExecutorService 다루기',
        'synchronized, ConcurrentHashMap 등 동시성 제어',
        '네트워크 프로토콜 설계 사고',
        '자원 누수 방지와 정상 종료 처리',
      ],
      techStack: ['Java 17', 'java.net Socket', 'ExecutorService', 'java.util.concurrent'],
    },
  ],

  'java-advanced': [
    {
      slug: 'ecommerce',
      title: '마이크로서비스 기반 전자상거래 플랫폼',
      description:
        'Spring Boot, Spring Cloud를 활용하여 확장 가능한 마이크로서비스 아키텍처 기반의 전자상거래 플랫폼을 구현합니다. 상품 관리, 주문 처리, 사용자 인증, 결제 시스템 등 다양한 서비스로 구성됩니다.',
      image: '/assets/images/java-advanced-project-ecommerce.png',
      skills: ['Spring Boot', 'Spring Cloud', '마이크로서비스', 'JPA', 'REST API'],
      overview:
        '하나의 모놀리식 쇼핑몰을 도메인 단위로 쪼개 마이크로서비스로 재설계합니다. 상품·사용자·주문·결제·알림을 각각 독립된 서비스로 구성하고, API Gateway를 앞단에 두어 라우팅과 인증을 처리합니다. 서비스 간 통신은 동기(REST/Feign)와 비동기(Kafka/RabbitMQ) 두 방식을 모두 다루며, 분산 환경 특유의 데이터 정합성·트랜잭션 문제(Saga 패턴)를 실습합니다.',
      features: [
        '상품·주문·사용자·결제·알림 5개 마이크로서비스 분리',
        'Spring Cloud Gateway 기반 API 게이트웨이',
        'JWT + OAuth2 인증/인가',
        'Saga 패턴으로 분산 트랜잭션 처리',
        '서비스 디스커버리(Eureka) + 분산 설정(Config Server)',
        'Docker Compose로 로컬 통합 환경 구성',
      ],
      learningGoals: [
        'DDD 관점에서의 서비스 경계 식별',
        'Spring Cloud 컴포넌트 조합 경험',
        '동기 vs 비동기 통신 선택 기준',
        '분산 추적과 로그 집계의 필요성 체감',
        'API 게이트웨이의 역할과 한계 이해',
      ],
      techStack: [
        'Spring Boot 3',
        'Spring Cloud Gateway',
        'Spring Cloud Config',
        'Eureka',
        'Spring Data JPA',
        'PostgreSQL',
        'Kafka',
        'Docker',
      ],
    },
    {
      slug: 'notification',
      title: '이벤트 기반 실시간 알림 시스템',
      description:
        '이벤트 소싱 및 CQRS 패턴을 적용한 실시간 알림 시스템을 개발합니다. 이벤트 기반 아키텍처를 통해 다양한 시스템 간의 느슨한 결합을 구현하고, 메시지 큐와 웹소켓을 활용하여 실시간 푸시 알림을 제공합니다.',
      image: '/assets/images/java-advanced-project-notification.png',
      skills: ['이벤트 소싱', 'Kafka', 'WebSocket', 'Spring WebFlux', 'NoSQL'],
      overview:
        '주문 완료, 결제 실패, 시스템 점검 등 다양한 도메인 이벤트가 발생했을 때 사용자별로 적절한 채널(웹/모바일/메일)로 알림을 보내는 시스템을 만듭니다. 이벤트 소싱으로 알림 이력을 추적 가능하게 보존하고, CQRS로 읽기 모델을 별도 최적화합니다. Kafka를 메시지 백본으로 두고 WebFlux 기반 리액티브 스트림으로 처리량을 확보합니다.',
      features: [
        '도메인 이벤트 발행 / 구독 (Kafka 토픽 기반)',
        '사용자 채널 설정에 따른 동적 라우팅',
        'WebSocket으로 실시간 푸시 / 미수신 시 폴백 메일 발송',
        '이벤트 스토어로 알림 이력 영구 보관 + 재처리',
        'CQRS: 읽기용 캐시(Mongo) + 쓰기용 이벤트 스토어',
      ],
      learningGoals: [
        'Event-Driven Architecture의 장단점 체득',
        'Kafka Producer/Consumer/Streams 운영',
        'Spring WebFlux와 리액티브 스트림 사용',
        'CQRS 패턴 구현과 일관성 모델 이해',
        '재시도 / 데드 레터 큐 / 멱등성 설계',
      ],
      techStack: [
        'Spring Boot 3',
        'Spring WebFlux',
        'Apache Kafka',
        'MongoDB',
        'Redis',
        'WebSocket / STOMP',
      ],
    },
    {
      slug: 'social-platform',
      title: '클라우드 네이티브 소셜 미디어 플랫폼',
      description:
        '클라우드 네이티브 아키텍처를 적용한 확장 가능한 소셜 미디어 플랫폼을 개발합니다. Kubernetes 환경에서 운영되며, CI/CD 파이프라인을 통한 자동화된 배포 프로세스를 구현합니다. 대용량 데이터 처리와 실시간 기능에 중점을 둡니다.',
      image: '/assets/images/java-advanced-project-social-platform.png',
      skills: ['Docker', 'Kubernetes', 'CI/CD', '클라우드 서비스', '분산 시스템'],
      overview:
        '게시글, 팔로우, 타임라인, 좋아요/댓글, 알림으로 구성된 소셜 플랫폼을 컨테이너 기반으로 처음부터 구축합니다. 모든 서비스를 Docker 이미지로 패키징하고 Kubernetes에 배포하여 무중단 배포와 오토스케일링을 실습합니다. GitHub Actions로 CI/CD를 구성하고, Prometheus/Grafana로 운영 가시성을 확보합니다.',
      features: [
        '게시글 / 팔로우 / 타임라인 / 알림 백엔드',
        'Kubernetes Deployment + HPA(오토스케일링)',
        'GitHub Actions 기반 CI/CD 파이프라인',
        'Helm 차트로 환경별 배포 분리(dev/stg/prod)',
        '분산 트레이싱(OpenTelemetry) + 메트릭(Prometheus)',
        'Object Storage(S3) 기반 미디어 파일 처리',
      ],
      learningGoals: [
        '12-Factor App 원칙 적용',
        'Kubernetes 핵심 리소스(Pod, Service, Ingress, ConfigMap) 이해',
        '컨테이너 이미지 최적화 (멀티스테이지 빌드)',
        '운영 환경에서의 가시성(observability) 구축',
        '비용/성능 트레이드오프 인식',
      ],
      techStack: [
        'Spring Boot 3',
        'Docker',
        'Kubernetes',
        'Helm',
        'GitHub Actions',
        'Prometheus',
        'Grafana',
        'AWS S3',
      ],
    },
  ],

  c: [
    {
      slug: 'calculator',
      title: '콘솔 기반 계산기 프로그램',
      description:
        'C의 기본 기능을 활용하여 덧셈, 뺄셈, 곱셈, 나눗셈 등의 연산이 가능한 계산기를 구현합니다. 예외 처리를 통해 견고한 애플리케이션을 만드는 방법을 경험합니다.',
      image: '/assets/images/c-project-calculator.png',
      skills: ['기본 문법', '함수 활용', '조건문', '입출력 처리'],
      overview:
        'C 언어의 절차적 사고와 함수 분리, 그리고 표준 입출력의 기본을 익히는 입문 프로젝트입니다. 단순 계산에서 시작해 후위표기법으로의 변환, 토큰 단위 파싱까지 단계적으로 확장하면서 알고리즘적 사고와 메모리 관리에 익숙해집니다. 문자열 처리와 숫자 변환 과정에서 발생하는 경계 케이스를 직접 처리해 보는 것이 핵심입니다.',
      features: [
        '사칙연산 및 괄호 우선순위',
        'scanf/printf 기반 사용자 인터페이스',
        '입력 형식 오류 검출 및 재입력 처리',
        '연산 결과 메모리 보관 (직전 결과 재사용)',
        '간단한 명령(c=clear, q=quit) 지원',
      ],
      learningGoals: [
        '변수, 자료형, 연산자, 제어문',
        '함수 정의와 호출, 반환값 처리',
        '문자열 처리(strtok, atof 등) 안전한 사용',
        '입력 검증과 방어적 코딩',
        '컴파일/링킹 단계 이해',
      ],
      techStack: ['C99', 'GCC / Clang', 'Make', 'GDB'],
    },
    {
      slug: 'grade-system',
      title: '학생 성적 관리 시스템',
      description:
        '배열을 사용하여 여러 학생의 점수를 저장하고 평균, 최고점, 최저점 등을 계산하는 프로그램을 개발합니다. 구조체와 파일 입출력을 활용하여 데이터를 영구 저장합니다.',
      image: '/assets/images/c-project-grade-system.png',
      skills: ['배열', '구조체', '파일 입출력', '함수 설계'],
      overview:
        'C의 구조체와 배열, 파일 입출력을 사용해 학생 정보와 성적을 관리하는 시스템을 만듭니다. 정적 배열의 한계를 느끼고 동적 메모리 할당으로 확장하면서 포인터 사용에 익숙해집니다. 텍스트 파일과 바이너리 파일 양쪽으로 영속화를 구현해 보면서 직렬화에 대한 감각을 익힙니다.',
      features: [
        '학생 등록 / 조회 / 수정 / 삭제',
        '평균·최고·최저 등 통계 계산',
        '학번·점수 기준 정렬',
        '텍스트 파일 / 바이너리 파일 입출력 양쪽 지원',
        '메뉴 기반 콘솔 UI',
      ],
      learningGoals: [
        'struct와 typedef 활용',
        '동적 메모리 할당(malloc/free)와 누수 방지',
        '포인터를 통한 함수 인자 전달',
        'fopen/fread/fwrite를 사용한 파일 I/O',
        '모듈 분리 (.h/.c) 기반 프로젝트 구성',
      ],
      techStack: ['C99', 'stdio.h', 'stdlib.h', 'Make', 'Valgrind(메모리 검사)'],
    },
    {
      slug: 'adventure-game',
      title: '텍스트 기반 어드벤처 게임',
      description:
        '조건문과 반복문, 함수를 활용하여 사용자 입력에 따라 스토리가 전개되는 텍스트 기반 게임을 개발합니다. 동적 메모리 할당과 파일 입출력을 통해 게임 상태를 저장하고 불러올 수 있습니다.',
      image: '/assets/images/c-project-adventure-game.png',
      skills: ['조건문 활용', '반복문', '함수 설계', '동적 메모리'],
      overview:
        '플레이어의 선택에 따라 스토리가 갈라지는 텍스트 어드벤처를 만들면서 상태 머신, 데이터 구조 설계, 그리고 영속화를 종합적으로 경험합니다. 인벤토리·체력·이벤트 플래그 같은 게임 상태를 구조체로 모델링하고, 저장/불러오기 기능으로 진행 상황을 유지합니다. 단순한 분기 트리에서 시작해 그래프 형태로 확장 가능한 시나리오 엔진으로 발전시킵니다.',
      features: [
        '선택지 기반 분기 시나리오 진행',
        '플레이어 상태(체력/인벤토리/플래그) 관리',
        '저장 / 불러오기 (세이브 슬롯 다중)',
        '시나리오 데이터를 외부 파일로 분리하여 모드/확장 가능',
        '간단한 전투/이벤트 시스템',
      ],
      learningGoals: [
        '복잡한 분기 로직을 함수로 추상화',
        '상태(state) 데이터 구조 설계',
        '파일 포맷 직접 정의 및 파싱',
        '메모리 관리와 자원 정리',
        '게임 루프와 사용자 입력 처리',
      ],
      techStack: ['C99', 'stdio.h', 'stdlib.h', 'string.h', 'Make'],
    },
  ],

  react: [
    {
      slug: 'task-manager',
      title: '할 일 관리 애플리케이션',
      description:
        'React와 Context API를 활용하여 할 일 목록을 관리하는 웹 애플리케이션을 구현합니다. CRUD 기능과 필터링, 테마 변경 등의 기능을 포함합니다.',
      image: '/assets/images/react-project-task-manager.png',
      skills: ['React Hooks', 'Context API', 'LocalStorage', '반응형 디자인'],
      overview:
        '함수형 컴포넌트와 Hooks 기반의 React 개발 흐름을 처음부터 익히는 입문 프로젝트입니다. CRUD가 가능한 할 일 목록을 만들면서 useState/useEffect, 컴포넌트 분리, props drilling 해결을 위한 Context API를 차례로 도입합니다. LocalStorage 영속화와 다크/라이트 테마 토글까지 포함하여 실제 서비스에 가까운 구색을 갖춥니다.',
      features: [
        '할 일 추가 / 수정 / 삭제 / 완료 토글',
        '전체 / 진행 중 / 완료 필터링',
        '우선순위 설정 및 드래그&드롭 정렬',
        '다크 / 라이트 테마 전환',
        'LocalStorage로 새로고침에도 유지',
      ],
      learningGoals: [
        'React 함수형 컴포넌트와 Hooks',
        'Context API로 전역 상태 관리',
        'useEffect와 부수 효과 다루기',
        '컴포넌트 단위 분리 사고',
        '반응형 CSS와 접근성(a11y) 기본기',
      ],
      techStack: ['React 18', 'Vite', 'styled-components', 'react-beautiful-dnd', 'LocalStorage'],
    },
    {
      slug: 'movie-search',
      title: '영화 정보 검색 서비스',
      description:
        '외부 영화 API를 활용하여 영화 정보를 검색하고 상세 정보를 볼 수 있는 서비스를 개발합니다. 비동기 데이터 처리와 라우팅을 활용한 멀티페이지 구현을 경험합니다.',
      image: '/assets/images/react-project-movie-search.png',
      skills: ['API 연동', 'React Router', '비동기 처리', '검색 기능'],
      overview:
        'TMDB 같은 공개 영화 API를 호출해 검색·상세보기·즐겨찾기를 제공하는 SPA를 만듭니다. 검색어 입력에 디바운스를 적용해 호출 횟수를 제어하고, 무한 스크롤로 결과를 페이징합니다. React Router로 검색 화면 ↔ 상세 화면 ↔ 즐겨찾기를 라우팅하며, 코드 스플리팅과 lazy loading으로 초기 로딩을 최적화합니다.',
      features: [
        '실시간 검색 (디바운스 적용)',
        '검색 결과 무한 스크롤 페이징',
        '영화 상세 화면 (포스터, 줄거리, 평점, 출연진)',
        '즐겨찾기 추가 / 제거 (LocalStorage)',
        '에러 / 로딩 / 빈 결과 상태 UI',
      ],
      learningGoals: [
        'fetch / axios 기반 비동기 데이터 처리',
        'React Router v6 라우팅과 동적 파라미터',
        'useDebounce 등 커스텀 훅 작성',
        '코드 스플리팅과 React.lazy / Suspense',
        '에러 바운더리와 로딩 UX 처리',
      ],
      techStack: ['React 18', 'React Router v6', 'Axios', 'TMDB API', 'styled-components'],
    },
    {
      slug: 'shopping-mall',
      title: '쇼핑몰 웹 애플리케이션',
      description:
        'Redux를 활용한 상태 관리와 Firebase 연동을 통해 실제 쇼핑몰과 유사한 기능을 구현합니다. 사용자 인증, 장바구니, 결제 프로세스 등 실무에서 필요한 기능을 개발합니다.',
      image: '/assets/images/react-project-shopping-mall.png',
      skills: ['Redux', 'Firebase', '인증/인가', '결제 통합'],
      overview:
        '상품 카탈로그, 장바구니, 주문, 결제까지 이어지는 전형적인 이커머스 흐름을 React + Redux + Firebase 조합으로 구현합니다. 상품/사용자/주문 데이터는 Firestore에, 인증은 Firebase Auth에 위임해 백엔드 없이도 풀스택에 가까운 경험을 만듭니다. Stripe 테스트 모드로 결제까지 연동해 결제 흐름의 단계와 보안 고려사항을 학습합니다.',
      features: [
        '상품 카탈로그 (카테고리/검색/정렬/필터)',
        '장바구니 추가·수량 변경·삭제 (Redux 영속화)',
        'Firebase Auth로 이메일/소셜 로그인',
        '주문 내역 조회 및 결제 상태 추적',
        'Stripe 테스트 결제 통합',
      ],
      learningGoals: [
        'Redux Toolkit 기반 상태 관리 패턴',
        'Firebase Auth / Firestore / Storage 운용',
        '인증 보호 라우트와 권한 가드',
        '폼 검증(react-hook-form, zod 등)',
        '외부 결제 SDK 연동 흐름',
      ],
      techStack: ['React 18', 'Redux Toolkit', 'Firebase Auth', 'Firestore', 'Stripe', 'react-hook-form'],
    },
  ],

  database: [
    {
      slug: 'smart-grid',
      title: '스마트 그리드 모니터링 시스템',
      description:
        '전력 사용량을 실시간으로 모니터링하고 분석하는 시스템의 데이터베이스를 설계합니다. 시계열 데이터 처리와 대용량 데이터 관리 방법을 학습합니다.',
      image: '/assets/images/database-project-smart-grid.png',
      skills: ['시계열 DB', '데이터 파티셔닝', '실시간 처리', '데이터 최적화'],
      overview:
        '수많은 계량기에서 초당 수천 건씩 들어오는 전력 사용량을 안정적으로 저장하고 빠르게 조회할 수 있는 데이터베이스 구조를 설계합니다. PostgreSQL + TimescaleDB 같은 시계열 확장을 사용해 대용량 시계열 데이터를 시간 단위로 파티셔닝하고, 사전 집계(continuous aggregates)로 대시보드 응답성을 확보합니다. 데이터 보존 정책과 압축까지 다뤄 운영 비용 관점도 함께 고려합니다.',
      features: [
        '계량기·지점·고객 도메인 ERD 설계',
        '시간 단위 파티셔닝 + 자동 청크 관리',
        '1분/1시간/1일 단위 사전 집계 뷰',
        '이상치(피크) 감지 쿼리 및 알람 트리거',
        '오래된 데이터 자동 압축 및 보존 정책',
      ],
      learningGoals: [
        '시계열 데이터의 특성과 일반 OLTP 차이',
        '파티셔닝 / 인덱스 / 사전 집계 트레이드오프',
        '쓰기 처리량 vs 조회 응답성 균형',
        '대시보드용 쿼리 최적화 기법',
        '데이터 라이프사이클 정책',
      ],
      techStack: ['PostgreSQL', 'TimescaleDB', 'pgAdmin', 'Grafana', 'Apache Kafka(데이터 수집)'],
    },
    {
      slug: 'facility-management',
      title: '설비 관리 시스템',
      description:
        '전기·통신 설비의 이력 관리, 유지보수, 고장 예측을 위한 데이터베이스를 설계합니다. 관계형 DB와 NoSQL을 결합한 하이브리드 아키텍처를 구현합니다.',
      image: '/assets/images/database-project-facility-management.png',
      skills: ['관계형 DB', 'MongoDB', '트랜잭션 관리', '데이터 무결성'],
      overview:
        '설비 자체의 정형 정보(자산, 위치, 계약, 점검 일정)는 관계형 DB로, 점검 로그·센서 측정값처럼 가변적이거나 반정형인 데이터는 MongoDB로 분리하는 하이브리드 모델을 설계합니다. 두 저장소 간 데이터 일관성을 유지하기 위한 동기화 전략과 트랜잭션 경계를 함께 고민하며, 실제 운영 환경에서의 데이터 무결성 이슈를 다룹니다.',
      features: [
        '설비·계약·점검 일정 ERD (PostgreSQL)',
        '점검 로그·이미지·센서 로그 (MongoDB)',
        '두 저장소 간 데이터 동기화 패턴 (Outbox)',
        '설비 이력 추적 + 감사(Audit) 로그',
        '고장 패턴 분석용 집계 쿼리',
      ],
      learningGoals: [
        'OLTP vs Document DB 사용 기준',
        '폴리글랏 퍼시스턴스의 장단점',
        '분산 환경에서의 데이터 정합성 패턴',
        '트랜잭션 경계 설계',
        '인덱스 전략 (B-tree, GIN, geo)',
      ],
      techStack: ['PostgreSQL', 'MongoDB', 'Redis', 'Debezium(CDC)', 'pgAdmin'],
    },
    {
      slug: 'telecom-network',
      title: '통신 네트워크 관리 시스템',
      description:
        '통신 네트워크의 구성 요소와 연결 관계를 효율적으로 관리하는 데이터베이스를 설계합니다. 그래프 데이터베이스의 활용 방법을 학습합니다.',
      image: '/assets/images/database-project-telecom-network.png',
      skills: ['그래프 DB', '네트워크 토폴로지', '경로 분석', '장애 감지'],
      overview:
        '통신 장비, 회선, 라우팅 경로처럼 본질적으로 그래프 구조를 가진 데이터를 Neo4j 같은 그래프 DB로 모델링합니다. 관계형 DB의 다중 JOIN으로는 표현이 어려운 N홉 경로 탐색·영향도 분석·최단 경로 계산을 Cypher 쿼리로 손쉽게 구현해 보면서 그래프 DB의 강점을 체득합니다. 장애 발생 시 영향 받는 고객/회선을 즉시 식별하는 시뮬레이션도 포함합니다.',
      features: [
        '장비·포트·회선·고객 노드 모델링',
        '연결 관계와 라우팅 경로 표현',
        '다중 홉 경로 탐색 및 최단 경로',
        '장비 장애 시 영향 범위 분석',
        '네트워크 토폴로지 시각화 데이터 제공',
      ],
      learningGoals: [
        '관계형 vs 그래프 DB의 본질적 차이',
        'Cypher 쿼리 작성',
        '그래프 알고리즘(Dijkstra, Centrality) 활용',
        '인덱스 / 제약조건 설계',
        '대용량 그래프 운영 고려사항',
      ],
      techStack: ['Neo4j', 'Cypher', 'APOC', 'Bloom(시각화)', 'Spring Data Neo4j'],
    },
  ],

  typescript: [
    {
      slug: 'task-manager',
      title: '할 일 관리 애플리케이션',
      description:
        'React와 TypeScript를 활용하여 할 일 목록을 관리하는 웹 애플리케이션을 구현합니다. 타입 안전한 상태 관리와 컴포넌트 설계를 경험합니다.',
      image: '/assets/images/typescript-project-task-manager.png',
      skills: ['React', 'TypeScript', '상태 관리', '커스텀 훅'],
      overview:
        '같은 할 일 앱을 TypeScript로 다시 만들면서 타입이 가져다주는 안정성과 자동완성의 차이를 직접 체감합니다. props/state/이벤트 핸들러에 적절한 타입을 부여하고, 유틸리티 타입과 제네릭으로 재사용 가능한 컴포넌트를 설계합니다. 런타임 검증이 필요한 부분에는 zod 같은 스키마 라이브러리를 결합해 컴파일 타임 타입과 런타임 검증을 일관되게 다룹니다.',
      features: [
        '엄격한 타입을 갖춘 CRUD 흐름',
        '제네릭 기반 재사용 가능한 List/Form 컴포넌트',
        'Discriminated Union으로 상태 머신 모델링',
        'zod 스키마로 LocalStorage 데이터 검증',
        '타입 안전한 커스텀 훅 (useToggle, useStorage 등)',
      ],
      learningGoals: [
        'React + TypeScript 기본 셋업',
        'Props / State / Event Handler 타입 패턴',
        '제네릭과 유틸리티 타입(Pick, Omit, Partial)',
        '런타임 타입 검증 (zod)',
        'tsconfig 옵션과 strict 모드 운영',
      ],
      techStack: ['TypeScript 5', 'React 18', 'Vite', 'zod', 'styled-components'],
    },
    {
      slug: 'monitoring-dashboard',
      title: '전기장비 모니터링 대시보드',
      description:
        '전기장비의 상태를 실시간으로 모니터링하는 대시보드를 개발합니다. TypeScript의 타입 시스템을 활용하여 복잡한 데이터 구조를 안전하게 처리합니다.',
      image: '/assets/images/typescript-project-monitoring-dashboard.png',
      skills: ['TypeScript', '차트 라이브러리', '인터페이스', '데이터 시각화'],
      overview:
        '센서로부터 들어오는 다양한 형태의 측정값을 안전하게 처리해 차트와 알림으로 보여주는 대시보드를 만듭니다. 측정 항목마다 단위·범위·임계치가 다르기 때문에 Discriminated Union과 제네릭으로 데이터 모델을 설계하고, WebSocket으로 실시간 갱신을 처리합니다. 차트 라이브러리와의 인터페이스에 강한 타입을 부여해 잘못된 데이터 매핑이 컴파일 단계에서 잡히게 합니다.',
      features: [
        '실시간 센서 데이터 수신 (WebSocket)',
        '시계열 차트 / 게이지 / 상태 카드 위젯',
        '임계치 초과 시 알림 + 색상 변경',
        '레이아웃 커스터마이징 (드래그&드롭)',
        '센서별 상세 페이지와 이력 조회',
      ],
      learningGoals: [
        '복잡한 도메인을 타입으로 모델링',
        'Discriminated Union을 활용한 안전한 분기',
        'WebSocket 메시지 타입 핸들링',
        '차트 라이브러리(Recharts/ECharts) 통합',
        '대용량 데이터의 클라이언트 최적화',
      ],
      techStack: ['TypeScript 5', 'React 18', 'Recharts', 'WebSocket', 'Tanstack Query', 'Vite'],
    },
    {
      slug: 'api-integration',
      title: 'API 통합 애플리케이션',
      description:
        '외부 API와 연동하여 데이터를 가져오고 처리하는 애플리케이션을 개발합니다. TypeScript의 제네릭과 유틸리티 타입을 활용하여 유연하고 견고한 코드를 작성합니다.',
      image: '/assets/images/typescript-project-api-integration.png',
      skills: ['API 연동', '비동기 처리', '제네릭', '유틸리티 타입'],
      overview:
        '서로 다른 외부 API(REST, GraphQL, OAuth 보호 자원)를 하나의 클라이언트로 통합하면서 타입 안전한 API 레이어를 설계합니다. 응답 스키마를 zod로 정의하고 거기서 자동 추론한 타입을 앱 전반에서 사용하여, API 변경이 컴파일 에러로 즉시 드러나도록 합니다. 재시도, 캐싱, 인증 토큰 갱신 같은 횡단 관심사도 함수 합성으로 깔끔하게 처리합니다.',
      features: [
        '여러 외부 API의 통합 데이터 뷰',
        'OAuth2 인증 + 토큰 자동 갱신',
        'zod 스키마로 응답 검증 + 타입 추론',
        '재시도 / 캐싱 / 백오프 지원 클라이언트',
        '상호 운용 가능한 어댑터 패턴',
      ],
      learningGoals: [
        '제네릭과 조건부 타입 활용',
        'API 응답 스키마 검증 패턴',
        'Tanstack Query로 비동기 상태 관리',
        '인증 토큰 흐름과 보안 고려사항',
        '횡단 관심사를 추상화하는 함수 합성',
      ],
      techStack: ['TypeScript 5', 'Tanstack Query', 'Axios', 'zod', 'OAuth2'],
    },
  ],

  'ai-coding': [
    {
      slug: 'on-pocket-news',
      title: 'On Pocket News 추천 서비스',
      description:
        '사용자 프로필과 관심사 기반으로 정책 뉴스를 개인화 추천하는 서비스를 구현합니다. 회원 가입, 추천 피드, 알림, 관리자 콘텐츠 카탈로그까지 포함한 서비스형 포트폴리오를 완성합니다.',
      image: '/assets/images/ai-project-on-pocket-news.png',
      skills: ['React', '추천 UX', '회원 프로필 설계', '관리자 콘솔', '콘텐츠 카탈로그'],
      demoLink: 'https://gen-lang-client-0493587853.web.app/',
      overview:
        '사용자 관심사·연령대·지역 같은 프로필을 기반으로 정책 뉴스를 개인화하여 보여주는 서비스를 풀스택으로 만듭니다. AI 도구를 활용해 요구사항 분해부터 컴포넌트 골격, 추천 로직 프로토타입까지 빠르게 빌드하고, 사용자 피드와 관리자 콘솔을 한 코드베이스에서 운영합니다. 단순 결과물이 아니라 실제로 운영 가능한 서비스 형태의 포트폴리오를 목표로 합니다.',
      features: [
        '관심사 / 지역 / 연령 기반 추천 피드',
        '소셜 로그인과 프로필 관리',
        '구독 키워드 기반 푸시 / 인앱 알림',
        '관리자용 콘텐츠 카탈로그 + 큐레이션',
        '사용자 행동 로그 기반 추천 개선 루프',
      ],
      learningGoals: [
        'AI 도구로 PRD → 코드까지 빠르게 진행하는 흐름',
        '추천 시스템의 기본 개념 (콘텐츠 기반 / 협업 필터링)',
        '사용자 화면과 관리자 화면의 분리/공유 전략',
        '실제 사용자에게 노출 가능한 수준의 UX 다듬기',
        '서비스로 배포·운영하는 경험',
      ],
      techStack: ['React', 'Firebase', 'Firestore', 'Cloud Functions', 'Tailwind CSS'],
    },
    {
      slug: 'blogger-pipeline',
      title: 'Blogger 콘텐츠 파이프라인',
      description:
        '아이데이션부터 생성, 리뷰, 보강, SEO 체크, 발행까지 이어지는 AI 기반 콘텐츠 운영 파이프라인을 구현합니다. 대기열 관리, 이미지 생성, 발행 워크플로, 운영 지표 시각화까지 다룹니다.',
      image: '/assets/images/ai-project-blogger-pipeline.png',
      skills: ['Workflow UI', '콘텐츠 자동화', 'SEO 체크', '발행 파이프라인', '운영 대시보드'],
      demoLink: 'https://blogger-daemon-v2.web.app/content-pipeline',
      overview:
        '블로그 콘텐츠를 생산·검수·배포하는 전체 파이프라인을 시각화하고 운영할 수 있는 도구를 만듭니다. 아이디어 큐에서 시작해 초안 생성 → 사실 검증 → SEO 점수 평가 → 이미지 생성 → 예약 발행까지 각 단계가 워크플로 노드로 연결되어 진행 상황을 한눈에 보여줍니다. 콘텐츠 운영자가 실제로 손에 쥐고 사용할 수 있는 수준의 인터페이스를 목표로 합니다.',
      features: [
        '단계별 콘텐츠 카드와 상태 머신 시각화',
        'AI 초안 생성 + 인간 리뷰 사이클',
        'SEO 점수 / 키워드 갭 자동 분석',
        '이미지 생성 / 교체 워크플로 통합',
        '예약 발행 / 발행 결과 추적 + 운영 대시보드',
      ],
      learningGoals: [
        '워크플로 UI의 상태 표현 패턴',
        'AI 호출의 비용·시간·실패 처리 설계',
        '비동기 작업 큐와 진행 상황 표시',
        '운영자 페르소나 중심 UX 설계',
        '지표 수집과 시각화',
      ],
      techStack: ['React', 'Firebase', 'OpenAI / Gemini API', 'Tailwind CSS', 'Recharts'],
    },
    {
      slug: 'agent-console',
      title: '멀티모델 Agent Console',
      description:
        '여러 AI 모델 공급자를 연결해 프롬프트 템플릿, 모델 레지스트리, 검증 결과, 에이전트 워크플로를 한 곳에서 운영하는 내부 콘솔을 구현합니다. 실무에서 바로 쓰이는 B2B형 관리 화면 설계를 경험합니다.',
      image: '/assets/images/ai-project-agent-console.png',
      skills: ['Admin UX', 'Prompt Ops', 'Model Registry', 'Validation Flow', 'Agent Workflow'],
      overview:
        'OpenAI·Anthropic·Google 등 여러 AI 모델 공급자를 한 곳에서 운영할 수 있는 내부용 관리 콘솔을 만듭니다. 프롬프트를 버전 관리하고, 모델 레지스트리에 등록된 모델로 동시에 실행해 결과를 비교하며, 검증 룰을 통과한 결과만 다음 단계로 흘려보내는 에이전트 워크플로를 구성합니다. B2B 어드민 도구의 정보 밀도와 안전장치를 어떻게 설계하는지 실무 감각으로 익힙니다.',
      features: [
        '프롬프트 템플릿 버전 관리 + diff 비교',
        '모델 레지스트리 (provider, 모델, 파라미터)',
        '동일 입력에 대한 멀티모델 동시 실행 + 비교',
        '검증 룰 / 평가 셋 기반 자동 채점',
        '단계별 에이전트 워크플로 정의 및 실행 추적',
      ],
      learningGoals: [
        '운영 관점의 Prompt Ops 설계',
        '여러 LLM 공급자를 추상화하는 어댑터',
        '평가(Eval) 자동화의 기본 개념',
        '대규모 폼/표/필터를 다루는 어드민 UX',
        '에이전트 워크플로의 노드/엣지 모델링',
      ],
      techStack: ['React', 'TypeScript', 'Tanstack Table', 'OpenAI / Anthropic / Gemini SDK', 'Tailwind CSS'],
    },
  ],
};

// 코스 slug → 코스 메타 (모달 헤더 색상 / breadcrumb 등에 사용)
export const courseMeta = {
  java: { name: 'Java 기초 과정', path: '/java', color: '#007396' },
  'java-advanced': { name: 'Java 고급 / 백엔드 과정', path: '/java-advanced', color: '#5d4037' },
  c: { name: 'C 언어 기초 과정', path: '/c', color: '#659ad2' },
  react: { name: 'React 프론트엔드 과정', path: '/react', color: '#61dafb' },
  database: { name: '데이터베이스 모델링 과정', path: '/database', color: '#f29111' },
  typescript: { name: 'TypeScript 과정', path: '/typescript', color: '#3178c6' },
  'ai-coding': { name: 'AI 코딩 / 포트폴리오 과정', path: '/ai-coding', color: '#16a085' },
};

export const findProject = (courseSlug, projectSlug) => {
  const list = projectsByCourse[courseSlug];
  if (!list) return null;
  const project = list.find((p) => p.slug === projectSlug);
  if (!project) return null;
  return { project, course: courseMeta[courseSlug] };
};
